import React from 'react'
import GaleriaSL from './GaleriaSL'

export default function Galeria() {
  return (
    <div className="pt-20"><GaleriaSL /></div>
  )
}
